const getHour = (isoDateString: string): string => {
  const date = new Date(isoDateString);
  const hour = date.getUTCHours();
  const period = hour >= 12 ? "PM" : "AM";
  const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
  return `${formattedHour}${period}`;
};

export default getHour;
